import React from 'react';
import styled from 'styled-components';
import { useLocation } from 'react-router-dom';

import { SemiBold } from '../../components/UI/Text';
import { MAIN_BLUE } from '../../styles/color';
import Button from '../../components/UI/Button';

const Container = styled.div`
	width: 80%;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	gap: 50px;
`;

function closeWindow() {
	window.close();
}

export default function FindPwResult() {
	const location = useLocation();
	const { tempPw } = location.state;
  	return (
		<Container>
			<SemiBold size="24px" style={{ textAlign: 'center' }}>임시 비밀번호는<br/>
				<span style={{ color: MAIN_BLUE.deep }}>{ tempPw }</span>
				&nbsp;<br/>
				입니다.
			</SemiBold>
			<Button buttonText="닫기" width="100%" height="60px" onClick={ () => closeWindow() }/>
		</Container>
  	)
}
